export const colorMap = new Map([
  [0, { name: 'MULTI', code: 'linear-gradient(135deg, #FA3232 17.19%, #FFBA34 27.34%, #FFF612 39.06%, #A3FF5A 49.61%, #3FF5CA 59.77%, #16BFFB 68.75%, #3F72F5 77.34%, #AF2CFF 87.11%)' }],
  [1, { name: 'BEIGE', code: '#CEC4AD' }],
  [2, { name: 'BLACK', code: '#000000' }],
  [3, { name: 'BLUE', code: '#1CBFFF' }],
  [4, { name: 'BROWN', code: '#805F3A' }],
  [5, { name: 'GOLD', code: 'linear-gradient(0deg, #B8A77B, #B8A77B), linear-gradient(137.6deg, #ABABAB 15.77%, #BCBCBC 26.89%, #DADADA 50.57%, #E9E9E9 61.7%, #C4C4C4 72.46%, #8E8D8D 84.66%)' }],
  [6, { name: 'GREEN', code: '#1C8C38' }],
  [7, { name: 'GREY', code: '#9C9C9C' }],
  [8, { name: 'NAVY', code: '#000080' }],
  [9, { name: 'ORANGE', code: '#FFB021' }],
  [10, { name: 'PINK', code: '#FFA1EA' }],
  [11, { name: 'PURPLE', code: '#6A36E3' }],
  [12, { name: 'RED', code: '#F54043' }],
  [13, { name: 'SILVER', code: 'linear-gradient(137.6deg, #ABABAB 15.77%, #BCBCBC 26.89%, #DADADA 50.57%, #E9E9E9 61.7%, #C4C4C4 72.46%, #8E8D8D 84.66%)' }],
  [14, { name: 'WHITE', code: '#FFFFFF' }],
  [15, { name: 'YELLOW', code: '#FFE433' }],
  [16, { name: 'CREAM', code: '#FFFDD0' }],

  // Not covered by BE API
  [17, { name: 'BLUSH', code: '#F4C2C2' }],
  [18, { name: 'CAMEL', code: '#C19A6B' }],
  [19, { name: 'CHARCOAL', code: '#36454F' }],
  [20, { name: 'DENIM', code: '#1560BD' }],
  [21, { name: 'LILAC', code: '#C8A2C8' }],
  [22, { name: 'STONE', code: '#DDC7A7' }],
  [23, { name: 'STRIPE', code: '#008cdd' }],
  [24, { name: 'WINE', code: '#722F37' }],
  [25, { name: 'REGULAR', code: '' }],
  [26, { name: 'LONG', code: '' }],

  // Additional supported colors
  [27, { name: 'TEAL', code: '#008080' }],
  [28, { name: 'OLIVE', code: '#708238' }],
  [29, { name: 'MINT', code: '#98FF98' }],
  [30, { name: 'LAVENDER', code: '#C8A2C8' }],
  [31, { name: 'MUSTARD', code: '#C49A00' }],
  [32, { name: 'TAN', code: '#D2B48C' }],
  [33, { name: 'BURGUNDY', code: '#800020' }],
  [34, { name: 'CRANBERRY', code: '#9F1D35' }],
  [35, { name: 'SAND', code: '#C2B280' }],
])

// Fallback color visually indicating "no color"
const NO_COLOR = {
  name: 'NO_COLOR',
  code: 'repeating-linear-gradient(135deg, #ffffff 0 45%, #000000 45% 55%, #ffffff 55% 100%)',
}

export const getColorCodeById = id => {
  const color = colorMap.get(id)
  return color?.code || NO_COLOR.code
}

export const getColorNameById = id => {
  const color = colorMap.get(id)
  return color?.name?.toLowerCase() || NO_COLOR.name.toLowerCase()
}

// O(1) lookup by uppercase color name
const colorByName = new Map(
  [...colorMap.values()].map(entry => [entry.name, entry]),
)

const isNumericId = value => typeof value === 'number' || (typeof value === 'string' && /^\d+$/.test(value))

const isMissing = value => value == null || value === ''

export const getColorCode = (color, hexCode) => {
  if (hexCode) return hexCode
  if (isMissing(color)) return NO_COLOR.code
  if (isNumericId(color)) return colorMap.get(Number(color))?.code || NO_COLOR.code
  return colorByName.get(color.toUpperCase())?.code || null
}

export const isUnknownColor = (colorFamily, hexCode) => {
  if (hexCode) return false
  if (!colorFamily) return true
  return !colorByName.has(colorFamily.toUpperCase())
}

const WHITE_BORDER = 'border-cader-gray'
const WHITE_NAMES = new Set(['white', 'no_color'])

const isWhiteById = color => color === 14 || color === '14'
const isWhiteByName = color => WHITE_NAMES.has(color?.toLowerCase?.() ?? '')

export const classForWhiteColor = (color, hexCode) => {
  if (hexCode) return hexCode.toUpperCase() === '#FFFFFF' ? WHITE_BORDER : undefined
  if (isWhiteById(color) || isWhiteByName(color)) return WHITE_BORDER
  return undefined
}
